import { container } from 'tsyringe';
import { BrowserFurnhomeCommunication, FurnhomeCommunicationToken } from '@dh-software/furnhome-communication';

// Muss laufen, bevor die Komponente geladen wird: deren Import definiert <dh-furnhome>, das im
// Dokument stehende Element wird dabei aufgewertet und der StateManager konstruiert - und der
// bekommt die Communication im Konstruktor. ES-Importe werden gehoben, die Registrierung kann
// deshalb nicht in derselben Datei davorstehen und bekommt eine eigene, die als Seiteneffekt
// importiert wird. Genauso halten es opusX-browser-client und administration-browser-client.
container.register(FurnhomeCommunicationToken, {
  useValue: new BrowserFurnhomeCommunication(String(import.meta.env.VITE_SERVER_URL ?? '')),
});
